module.exports = __webpack_public_path__ + "img/s2_stepimg02@2x.4430f3a5.png";